import React from 'react';

import { AcknowledgeIntro, AcknowledgeSteps, AcknowledgePanelProps } from './AcknowledgePanel';
import { PanelCard } from './styles';

/**
 * Mobile (embedded) layout splits the single side panel into two stacked cards: the intro card
 * sits above the document, the actions card below it. The content is shared with AcknowledgePanel
 * (web) so copy and button logic have one source of truth.
 */
export const AcknowledgeIntroPanel = (): React.ReactElement => (
  <PanelCard aria-label="Acknowledge document">
    <AcknowledgeIntro />
  </PanelCard>
);

export const AcknowledgeActionsPanel = ({ hasReadToEnd, onAcknowledge }: AcknowledgePanelProps): React.ReactElement => (
  <PanelCard>
    <AcknowledgeSteps hasReadToEnd={hasReadToEnd} onAcknowledge={onAcknowledge} />
  </PanelCard>
);
